'use client';

import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';

import { getCurrentCurrencyData } from '@/helpers/common';
import { QUERY_VIP } from '@/helpers/modals';
import { useABTesting } from '@/hooks/abTesting';
import { DEFAULT_AMOUNTS } from '@/modules/deposit';
import { useCommonStore } from '@/store';

const PRICE_GAP = 1;

export enum InvreasedPrevDepEnum {
  A = 'a_default_prev_preset_sum',
  B = 'b_incr_prev_preset_sum',
}

export const useABIncreasePrevDep = () => {
  const user = useCommonStore.use.user();
  const currencies = useCommonStore.use.currencies();

  const searchParams = useSearchParams();

  const lastSuccessfulPaymentsByCurrency =
    useCommonStore.use.lastSuccessfulPaymentsByCurrency();
  const pending = useCommonStore.use.lastSuccessfulPaymentsByCurrencyPending();

  const { turnOffTest, transactionSum } = useMemo(() => {
    if (!user || searchParams.get(QUERY_VIP)) {
      return {
        turnOffTest: true,
        transactionSum: 0,
      };
    }

    const defaultSum = DEFAULT_AMOUNTS[user.currency];
    const amountCents = lastSuccessfulPaymentsByCurrency[user.currency] || 0;

    const transactionSum = getCurrentCurrencyData(
      amountCents,
      user.currency,
      currencies
    ).amount;

    return {
      turnOffTest: transactionSum < defaultSum + PRICE_GAP,
      transactionSum,
    };
  }, [searchParams, lastSuccessfulPaymentsByCurrency, user?.currency]);

  const isIncreasedPrevDep =
    useABTesting('exp_increased_prev_dep_lu', {
      defaultVersion: InvreasedPrevDepEnum.A,
      versions: [
        { name: InvreasedPrevDepEnum.A, probability: 50 },
        { name: InvreasedPrevDepEnum.B, probability: 50 },
      ],
      turnOffTest,
    }) === InvreasedPrevDepEnum.B;

  return { isIncreasedPrevDep, transactionSum, transactionPending: pending };
};
